<template>
  <button
    type="button"
    class="hb-icon-button"
    :class="`hb-icon-button--${tone}`"
    :aria-label="label"
    :title="label"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <feather-icon :icon="icon" size="17" />
  </button>
</template>

<script>
/**
 * Acao de linha: quadrado de 36px, so icone, colorido por intencao.
 *
 * A cor codifica a acao, seguindo a convencao ja usada nas grids do app:
 * primary = gerar/copiar link, warning = material, success = ver detalhes,
 * danger = remover.
 *
 * O `label` e obrigatorio: sem rotulo visivel, o aria-label e o title sao a unica forma
 * de saber o que o botao faz.
 */
export default {
  name: 'HbIconButton',
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    tone: {
      type: String,
      default: 'primary',
      validator: v => ['primary', 'success', 'warning', 'danger', 'secondary'].includes(v),
    },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.hb-icon-button {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: var(--radius);
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-in-out);
}

.hb-icon-button:disabled {
  opacity: 0.65;
  cursor: default;
}

.hb-icon-button--primary { color: var(--primary); }
.hb-icon-button--success { color: var(--success); }
.hb-icon-button--warning { color: var(--warning); }
.hb-icon-button--danger { color: var(--danger); }
.hb-icon-button--secondary { color: var(--secondary); }

.hb-icon-button--primary:hover:not(:disabled) { background: var(--tint-primary); }
.hb-icon-button--success:hover:not(:disabled) { background: var(--tint-success); }
.hb-icon-button--warning:hover:not(:disabled) { background: var(--tint-warning); }
.hb-icon-button--danger:hover:not(:disabled) { background: var(--tint-danger); }
.hb-icon-button--secondary:hover:not(:disabled) { background: var(--tint-secondary); }
</style>
